import { CatalogCell } from "@ext/enterprise/components/admin/settings/resources/CatalogCell";
import type { CatalogRow } from "@ext/enterprise/components/admin/settings/resources/model/CatalogRow";
import t from "@ext/localization/locale/translate";
import type { ColumnDef } from "@ui-kit/DataTable";

export const catalogColumnId = "catalog";

const toSearchText = (row: CatalogRow): string => `${row.title} ${row.repo}`;

export const catalogColumn = <T,>({ getRow }: { getRow: (item: T) => CatalogRow }): ColumnDef<T> => ({
	id: catalogColumnId,
	accessorFn: (item) => toSearchText(getRow(item)),
	header: t("name"),
	cell: ({ row }) => <CatalogCell row={getRow(row.original)} />,
});
